import { TDragItemSize } from './chatbot.types';

export const FAB_SIZE = 56;
export const PANEL_EDGE_MARGIN = 10;
export const FAB_EDGE_MARGIN = 20;
export const PANEL_WIDTH_PX = 500;
export const PANEL_HEIGHT_VH = 70;

export const FAB_BOX: TDragItemSize = { width: FAB_SIZE, height: FAB_SIZE };

export const HEARTBEAT_INTERVAL_MS = 30_000;
export const HEARTBEAT_SILENCE_TIMEOUT_MS = 10_000;

export const RECONNECT_BASE_DELAY_MS = 2_000;
export const RECONNECT_MAX_DELAY_MS = 60_000;

export const MAX_RESPONSES = 50;

export const START_NEW_CHAT_CONFIRMATION = {
  header: 'Start New Chat?',
  content: ['This will clear the current conversation and start a new chat.'],
  primaryBtnTxt: 'Start New Chat',
  closeModalBtnTxt: 'Cancel',
};

/** Highcharts exporting menu options supported on native platforms */
export const NATIVE_CHART_MENU_ITEMS = ['viewFullscreen', 'viewData'];

/** How close to the bottom still counts as following the stream. */
export const SCROLL_PIN_THRESHOLD_PX = 24;
